export const GOAL_COMPLETION = {
    exceeded: {
        en: 'I exceeded my goal',
        es: 'Superé mi objetivo'
    },
    completed: {
        en: 'I completed my goal',
        es: 'Cumplí mi objetivo'
    },
    partial: {
        en: 'I partially completed my goal',
        es: 'Cumplí parcialmente mi objetivo'
    },
    dnc: {
        en: 'I did not complete my goal',
        es: 'No cumplí mi objetivo'
    }
} as Record<string, { en: string; es: string }>;
